import React from "react";
import {Outlet, useParams} from "react-router-dom";
import UserList from "./UsersList";
// import {AuthUser} from "../../services/AuthService";
// import {useAuth} from "../auth/AuthenticationProvider";

const Users = (): JSX.Element => {
  const {userId} = useParams();

  const content = userId ? <Outlet /> : <UserList />;

  return content;
};

export default Users;
